export default {
  oma: {
    fromDate: "Data",
    toDate: "A data",
    selectDate: "Seleziona la data",
    cancel: "CANCELLAZIONE",
    avocadoTreesList: "Lista alberi di Avocado",
    addTreesManually: "Aggiungi GeoLocation albero Manuale",
    confirmationTitle: "Conferma",
    confirmationMessage: "Avocadao L'albero ha aggiunto/edited correttamente",
    addTreesBulk: "Importare alberi in massa",
    addNewFarm: "Seleziona Agriturismo",
    selectFarm: "Seleziona Agriturismo",
    selectZone: "Seleziona la zona",
    treeId: "Albero Id",
    treeName: "Nome dell'albero",
    zoneId: "Zone Id",
    latitude: "Latitudine",
    longitude: "Longitudine",
    altitude: "Altitudine",
    timestamp: "tempo di tempo",
    avocadoTrees: "Alberi Avocado",
    landSuitibility: "Soddisfazione della terra",
    landSuitibilityReport: "Soddisfazione della terra Relazione",
    generateNewReport: "Generare un nuovo rapporto",
    operatorName: "Nome operatore",
    issueDate: "Data di pubblicazione",
    chooseYourLocation: "Scegli la tua posizione",
    getLandEvaluation: "Ottenere la valutazione del terreno",
    downloadPdfReport: "Scarica il report pdf",
    pleaseEnterCoordinateText:
      "Si prega di inserire le coordinate (longitudine e latitudine) della posizione fattoria per vedere il suo punteggio.",
    noRecordAvailable: "Nessun risultato disponibile.",
    overallScoreForLand:
      "Punteggio complessivo per la sostenibilità del terreno",
    landEvaluation: "Valutazione della terra",
    unsuitable: "Inadatto",
    marginally: "Margine",
    suitable: "Adatto",
    moderately: "Moderatamente",
    highly: "Altamente",
    back: "Indietro",
    search: "Ricerca",
    showResults: "Mostra i risultati",
    weatherAnalysisReport: "Rapporti di analisi meteo",
    weatherAnalysis: "Analisi del tempo",
    weatherReport: "Rapporto di tempo",
    getWeatherAnalysis: "Ottieni analisi meteo",
    filterByDate: "Filtra per data",
    insertCoordinateText:
      "Inserire le coordinate dell'agriturismo (o albero) posizione sopra, o utilizzare la mappa qui sotto per indicare la posizione dell'agriturismo (o albero).",
    addTreeGeolocation: "Aggiungi Geolocalizzazione albero",
    editTreeGeolocation: "Modifica Geolocalizzazione albero",
    plantationDate: "Data impianto",
    notes: "Note",
    uploadTreeImages: "Carica immagini albero",
    valueAtTheCoordinatesOfInterest: "Valore al Coordinamento di Interesse",
    "Slope (%)": "Slope (%)",
    "Soil texture (USDA class)": "Texture del terreno (classe USDA)",
    "Coarse fragments (vol%)": "Frammenti grossolani (vol%)",
    Land: "Terreno",
    "Artificial surfaces (type)": "Superfici artificiali (tipo)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Prossimità a Tipo 1 e 2 Strade (metri)",
    "Soil Chemical Properties": "Proprietà chimiche del suolo",
    "Soil Physical Properties": "Proprietà fisiche del suolo",
    "Soil organic carbon (%)": "Biossido di carbonio organico (%)",
    "Soil pH": "PH del suolo",
    "Soil salinity (ECe))": "Salinità del suolo (ECe)",
    "Mean annual temperature (°C)": "Temperatura media annuale (°C)",
    Weather: "Tempo",
    "Mean minimum temperature of coldest month (°C)":
      "Temperatura minima media del mese più freddo (°C)",
    "Mean annual precipitation (mm)": "Pioggia annuale media (mm)",
    avocadoDetailNoUpdates: "Nessun aggiornamento",
    avocadoTreeDetail: "Dettagli sull'albero",
    avocadoTreeDetailHeader: "Dettagli dell'albero di Avocado",
    avocadoTreeUpdates: "Aggiornamenti dell'albero di Avocado",
    avocadoAddImages: "Aggiungi nuove immagini",
    addNewTreeImage: "Aggiungi nuove immagini albero",
    selectCountry: "Seleziona Paese",
    allRegions: "Tutte le regioni",
    avocadoDetailCard: {
      clientTreeId: "ID albero",
      treeName: "Nome dell'albero",
      latitude: "Latitudine",
      longitude: "Longitudine",
      altitude: "Altitudine",
      zoneId: "ID zona",
      createdAt: "Data e ora",
      plantationDate: "Data e ora",
      updatedAt: "Ultimo aggiornamento",
    },
    importCSVFormat: "Importazione CSV Formato",
    importGeoJsonFormat: "Importazione di GeoJSON Formato",
    importShapeFilesFormat: "Formato dei file di forma di importazione",
    importXLSFormat: "Importazione XLS Formato",
    importGeobufFormat: "Importazione Geobuf Formato",
    importGeoPackageFormat: "Importazione GeoPackage Formato",
    importTopoJsonFormat: "Importare TopoJSON Formato",
    avocadoTreeDetailsTableHeader: {
      updatedOn: "Aggiornato su",
      updatedBy: "Aggiornato da",
      notes: "Note",
      noOfImages: "No. delle immagini",
      actions: "Azione",
    },
    avocadoTreeView: "Vista sull'albero",
    avocadoFarmView: "Vista sul mare",
    avocadoTreeDetailPopupTitle: "Visualizza dettagli sull'albero",
    dateOfInterest: "Data di interesse",
    maximumCloudCoverage: "Copertura massima del cloud",
    import: "Importazioni",
    history: "Storia",
    downloandimport: "Scarica e Importa",
    importantNote: "Nota importante",
    downloadXlsFormat: "Scarica XLS Formato",
    downloadCSVFormat: "Scarica CSV Formato",
    downloadGeoJSONFormat: "Scarica GeoJSON Formato",
    downloadTopoJSONFormat: "Scarica TopoJSON Formato",
    downloadGeoPackageFormat: "Scarica il formato GeoPackage",
    downloadGeobufFormat: "Scarica il formato Geobuf",
    selectXLSFile: "Selezionare XLS File",
    selectCSVFile: "Selezionare CSV File",
    selectGeoJSONFile: "Seleziona GeoJSON File",
    selectTopoJSONFile: "Seleziona TopoJSON File",
    selectGeoPackageFile: "Selezionare GeoPackage File",
    selectGeobufFile: "Selezionare Geobuf File",
    OrDragDrop: "o trascina qui",
    importTrees: "Importa alberi",
    importantNoteDetail:
      "Si prega di utilizzare i modelli forniti sopra per caricamenti di massa.\nAltri formati si tradurranno in fallimento.",
    fileName: "Nome del file",
    importedOn: "Importato su",
    status: "Stato",
    actions: "Azione",
    action: "Azione",
    download: "Scarica",
    removeFile: "Rimuovi file",
    importedTrees: "Alberi importati",
    geolocation: "Geolocalizzazione",
    "Export CSV Format": "Esportazione CSV Formato",
    "Export XLSX Format": "Esportazione formato XLSX",
    "Export PDF Format": "Esportazione PDF Formato",
    noHistoryFound: "Nessuna storia trovata",
  },
};
